import { apiRequest } from "./client";

export interface User {
  id: string;
  email: string;
  full_name: string;
  role: "admin" | "manager";
  bitrix_user_id: string | null;
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserListResponse {
  items: User[];
  total_count: number;
}

export interface UserListQuery {
  page?: number;
  size?: number;
  role?: "admin" | "manager";
  is_active?: boolean;
  search?: string;
}

export interface UserCreatePayload {
  email: string;
  full_name: string;
  role: "admin" | "manager";
  bitrix_user_id?: string | null;
}

export interface UserPatchPayload {
  full_name?: string;
  role?: "admin" | "manager";
  bitrix_user_id?: string | null;
  is_active?: boolean;
}

function buildQuery(query: UserListQuery): string {
  const params = new URLSearchParams();
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  if (query.role !== undefined) params.set("role", query.role);
  if (query.is_active !== undefined) params.set("is_active", String(query.is_active));
  if (query.search) params.set("search", query.search);
  const s = params.toString();
  return s ? `?${s}` : "";
}

export const usersApi = {
  list: (query: UserListQuery = {}) =>
    apiRequest<UserListResponse>(`/users${buildQuery(query)}`),
  get: (id: string) => apiRequest<User>(`/users/${id}`),
  create: (payload: UserCreatePayload) =>
    apiRequest<User>("/users", { method: "POST", body: payload }),
  patch: (id: string, payload: UserPatchPayload) =>
    apiRequest<User>(`/users/${id}`, { method: "PATCH", body: payload }),
  deactivate: (id: string) =>
    apiRequest<User>(`/users/${id}/deactivate`, { method: "POST", body: {} }),
  revokeSessions: (id: string) =>
    apiRequest<User>(`/users/${id}/revoke-sessions`, { method: "POST", body: {} }),
};
